import { PageSection } from 'components';
import {
    ACADEMY_ALLIANCE_REVIEWS_EN,
    ACADEMY_ALLIANCE_REVIEWS_RU,
} from 'consts';
import {
    DotsContainer,
    DotsList,
} from 'containers/pages/for-businesses/components/reviews/styled';
import { useTranslation } from 'react-i18next';
import Slider, { Settings } from 'react-slick';
import { AcademyReview } from 'types/alliance';
import { Title } from '../../styled';
import {
    Arrow,
    ArrowContainer,
    CarouselArrows,
    Container,
    Review,
    ReviewDescription,
    ReviewImage,
    ReviewText,
    ReviewTitle,
    SliderStyler,
    Subtitle,
    SubtitleWrapper,
    TitleContainer,
    TitleWrapper,
} from './styled';
import { Icon } from 'kl-b2c-ui-kit';
import DOMPurify from 'dompurify';
import { useRef } from 'react';

const sectionConfig = {
    CWrap: {
        css: {
            paddingTop: 0,
            paddingBottom: 90,

            '@media(max-width: 1279px)': {
                paddingBottom: 44,
            },
        },
    },
    ContentArea: {
        css: {
            display: 'block',
            position: 'relative',
            zIndex: 5,

            '@media(max-width: 1023px)': {
                paddingTop: '0 !important',
            },
        },
    },
};

export const Reviews = () => {
    const { t } = useTranslation('pages/academy-alliance');
    const sliderRef = useRef<Slider>(null);

    const CAROUSEL_SETTINGS: Settings = {
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        infinite: false,
        responsive: [
            {
                breakpoint: 1023,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
        appendDots: (dots) => (
            <DotsContainer>
                <DotsList
                    styles={{
                        '.slick-active': {
                            background: '#7733FF',
                            opacity: '1',
                        },
                        li: {
                            opacity: '0.5',
                            background: '#7733FF',
                        },
                    }}>
                    {dots}
                </DotsList>
            </DotsContainer>
        ),
    };

    return (
        <Container>
            <PageSection config={sectionConfig}>
                <TitleWrapper>
                    <Title>{t('reviews-title')}</Title>
                </TitleWrapper>
                <SubtitleWrapper>
                    <Subtitle>{t('reviews-subtitle')}</Subtitle>
                    <CarouselArrows>
                        <Arrow onClick={() => sliderRef?.current?.slickPrev()}>
                            <Icon
                                name={'ArrowLeftThin'}
                                color={'white'}
                                size={25}
                            />
                        </Arrow>
                        <Arrow onClick={() => sliderRef?.current?.slickNext()}>
                            <Icon
                                name={'ArrowRightThin'}
                                color={'white'}
                                size={25}
                            />
                        </Arrow>
                    </CarouselArrows>
                </SubtitleWrapper>

                <SliderStyler>
                    <Slider {...CAROUSEL_SETTINGS} ref={sliderRef}>
                        {(process.env.REACT_APP_LOCALE === 'ru'
                            ? ACADEMY_ALLIANCE_REVIEWS_RU
                            : ACADEMY_ALLIANCE_REVIEWS_EN
                        ).map((review: AcademyReview, index: number) => (
                            <Review
                                index={index}
                                key={index}
                                href={review.link}
                                target={'_blank'}>
                                <ReviewText>
                                    <TitleContainer>
                                        <ReviewTitle
                                            dangerouslySetInnerHTML={{
                                                __html: DOMPurify.sanitize(
                                                    review.title
                                                ),
                                            }}
                                        />
                                        <ArrowContainer>
                                            <Icon
                                                name={'ArrowRightThin'}
                                                color={'primary'}
                                                size={30}
                                            />
                                        </ArrowContainer>
                                    </TitleContainer>

                                    <ReviewDescription>
                                        {review.description}
                                    </ReviewDescription>
                                </ReviewText>
                                <ReviewImage
                                    image={review.image}
                                    isFull={
                                        process.env.REACT_APP_LOCALE === 'en' &&
                                        index === 0
                                    }
                                />
                            </Review>
                        ))}
                    </Slider>
                </SliderStyler>
            </PageSection>
        </Container>
    );
};
